import { Textbox as TextboxAtom } from '../../atoms/Textbox';
import { useFormInput } from 'context/form';

export function Textbox({
  fieldId,
  formId,
  invalidMessage,
  label,
  multiline,
  validator,
  required,
  type,
  registrationFunction,
}: {
  fieldId: string;
  formId: string;
  invalidMessage?: string;
  label?: string;
  multiline?: boolean;
  validator?: (value: string) => boolean;
  required?: boolean;
  type?: "text" | "email" | "tel" | "number" | "password";
  registrationFunction?: (value: string) => Object;
}) {
  const { onBlur, onChange, valid, value } = useFormInput(formId, fieldId, {
    validator,
  });

  return (
    <TextboxAtom
      invalidMessage={invalidMessage}
      label={label}
      fieldId={fieldId}
      multiline={multiline}
      onBlur={onBlur}
      onChange={onChange}
      required={required}
      type={type}
      registrationFunction={registrationFunction}
    />
  );
}
